import styles from "./LinkPageMap.module.scss";

interface ILinkPageMapProps {
  address: string | null;
}

/**
 * A small Google Maps embed of the studio's address, shown under the contact cards. Keyless:
 * the plain `output=embed` URL needs no API key. Rendered only when an address is published —
 * an exact map link without address text has nothing reliable to search by.
 */
export const LinkPageMap = ({ address }: ILinkPageMapProps) => {
  const query = address?.trim();

  if (!query) {
    return null;
  }

  return (
    <div className={styles.root}>
      <iframe
        className={styles.root_frame}
        title={`Карта: ${query}`}
        src={`https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    </div>
  );
};
